import type { Page } from '@/components/canvas/document/publicTypes';

/** 复制页名称：有名称时在末尾追加「副本」 */
export function duplicatePageDisplayName(source: Page): string {
  const trimmed = source.name.trim();
  if (!trimmed) return '';
  return `${trimmed}副本`;
}
